import Utils from '../../utils/utils.js'
import LogHelper from '../../utils/logHelper.js'
const utilsHelper = new Utils()
import PagePlugin from '../../page_plugin/index.js'

export default class NineyiTraceService {

    constructor(container_id, config, is_debug, storage_key) {

        this.config = config
        this.container_id = container_id
        this.is_debug = is_debug
        this.storage_key = storage_key
        // 一天
        this.expired_min = 300
        this.logHelper = new LogHelper(config.LOG_LEVEL, config.LOG_ENDPOINT, is_debug, container_id)
        this.currency_iso = 'TWD'
        
    }

    run() {

        try {

            let clid = ''
            try {
                let s_clid = utilsHelper.getClidByContainerId(this.storage_key)
                if (s_clid) {
                    clid = s_clid
                }
            } catch (error) {
                clid = ''
            }

            // 預打訂單
            if (window.location.href.includes('/ShoppingCart') && window.location.href.includes('Finish') === false) {
                this.prePlaceOrderBtn(clid)
                if (window.clarity) {
                    window.clarity("upgrade", "checkout_page")
                }
                // this.prePlaceOrder()
            }

            // 付款成功會跳回來但可能分成
            // 1. 新開預設browser情境(從未登入過)
            if (window.location.href.includes('/Login/Index') && window.location.href.includes('Cancel') === false) {
                this.completeOrder('login')
            }

            // 1. 信用卡 & 超商都ok，因為不會翻其他瀏覽器
            // 2. LinePay跳轉回來，但預設瀏覽器有登入過，會直接進訂單完成頁(表示有曾經登入過)
            if (window.location.href.includes('/Pay/Finish')) {
                this.confirmOrder(clid)
                if (window.clarity) {
                    window.clarity("upgrade", "purchase_page")
                }
            }

        } catch (error) {
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_nineyi_run',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack
                  }
            })
            // throw Error(error)
        }

    }

    abTestCallBack(views){
        try {
            console.log('optimize99_callback_shopline:', views)

            // if (views.length === 0 ){
            //     return
            // }

            // 建立加入購物車的事件追蹤
            this.addToCart(views)

        } catch (error) {
            // throw Error(error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_shopline_abTestCallBack',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack
                }
            })
        }
    }

    addToCart(views){
        console.log('optimize99_add2cart', views)

        let that = this
        const cart_btn_ids = [
            // 'btn-add-to-cart', 'btn-main-checkout'
        ]
        const cart_btn_classnames = [
            'add-to-cart-btn', 'immediately-buy-btn', 'sale-page-btn'
        ]
        document.addEventListener('click', function(event){
            // console.log('click', event)

            let target_ele = event.target
            if (target_ele instanceof HTMLElement === false) {
                if (target_ele.parentElement instanceof HTMLElement === false) {
                    return
                }
                else {
                    target_ele = target_ele.parentElement 
                }
            }


            let is_match = false

            for(let idx = 0; idx < cart_btn_classnames.length; idx++){
                if (target_ele.closest(`.${cart_btn_classnames[idx]}`)){
                    is_match = true
                    break
                } 
            }

            if (is_match === false) {
                for (let idx = 0; idx < cart_btn_ids.length; idx++) {
                    if (target_ele.closest(`#${cart_btn_ids[idx]}`)){
                        is_match = true
                        break
                    } 
                }
            }

            if (is_match === false) {
                return
            }
            console.log('optimize99_add2cart: ', is_match)
            that.sendCartEvent(views)
            
        })

    }

    sendCartEvent(views) {
        let clid = ''
        try {
            let s_clid = utilsHelper.getClidByContainerId(this.storage_key)
            if (s_clid) {
                clid = s_clid
            }
            
        } catch (error) {
            clid = ''
        }
        try {
            let that = this
            let path = window.location.pathname.toLocaleUpperCase()
            if (path.includes('/SALEPAGE/INDEX/')) {

                // product_id
                let url_product_id = path.replace('/SALEPAGE/INDEX/', '')
                let ele_product_id = document.querySelector('div[ng-bind="SalePageIndexCtrl.SalePageId"]').innerText
                let product_id = ''
                if (url_product_id !== ele_product_id) {
                    product_id = ele_product_id
                }
                else {
                    product_id = url_product_id
                }

                // product name
                let product_name = document.querySelector('.salepage-title').innerText

                // product price 
                let product_price = 1
                let price_ele = document.querySelector('.salepage-price')
                if (price_ele) {
                    product_price = utilsHelper.getNumbersFromString(price_ele.innerText)
                }
                else {
                    price_ele = document.querySelector('.salepage-suggestprice').innerText
                    if (price_ele) {
                        product_price = utilsHelper.getNumbersFromString(price_ele.innerText)
                    }
                }

                let product = {
                    content_id: product_id,
                    content_name: product_name,
                    price: product_price,
                    quantity: 1
                }

                let events = []
                events = views.map(function(view){
                    view = view.view
                    let event = {
                        "container_id": that.container_id,
                        "event": "AddToCart",
                        "event_id": new Date().getTime(),
                        "clid": clid,
                        "vid": view.vid,
                        "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                        "value": product.price,
                        "content": {
                            contents: [product],
                            currency: that.currency_iso
                        }
        
                    }
                    return event
                })
        
            
                console.log('optimize99_add_cart_events', events)
                if (events.length === 0){
                    let force_event = {
                        "container_id": that.container_id,
                        "event": "AddToCart",
                        "event_id": new Date().getTime(),
                        "clid": clid,
                        "vid": "",
                        "url": decodeURIComponent(decodeURIComponent(window.location.href)),
                        "value": product.price,
                        "content": {
                            contents: [product],
                            currency: that.currency_iso
                        }

                    }

                    utilsHelper.callAPI(
                        '', 
                        'POST', 
                        that.config.API_ENDPOINT + '/view/report', 
                        force_event
                    )

                    that.logHelper.send({
                        "level": 'info',
                        "view": "",
                        "stage": 'trace_nineyi_add_cart',
                        "request_payload": JSON.stringify(force_event),
                        "api_url": that.config.API_ENDPOINT + '/view/report',
                        "clid": clid,
                    })
        

                }


                // 送事件
                events.forEach(function(event){
        
                    that.logHelper.send({
                        "level": 'info',
                        "view": event.vid,
                        "stage": 'trace_nineyi_add_cart',
                        "request_payload": JSON.stringify(event),
                        "api_url": that.config.API_ENDPOINT + '/view/report',
                        "clid": clid,
                    })
        
                    utilsHelper.callAPI(
                        '', 
                        'POST', 
                        that.config.API_ENDPOINT + '/view/report', 
                        event
                    )
                })

                console.log('optimize99_add_cart_item:', product)
            }
        } catch (error) {
            console.log('trace_nineyi_add_to_cart-error', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_nineyi_add_to_cart',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack
                }
            })
        }
        
    }

    confirmOrder(clid){
        let that = this
        console.log('optimize99_confirmOrder')
        try {

            let order = window.nineyi.ServerData
            
            if (!clid) {
                console.log('no_clid')
                this.completeOrder('order_finished')
                return
            }

            let products = order.displaySalePageGroupList[0].SalePageList.map(function(item){
                let product = {}
                // 用來找看過哪些view的product_id都用平台id
                product['content_id'] = item.SalePageId
                product['content_name'] = item.Title
                product['content_sku'] = item.SaleProductSkuOuterId
                product['currency'] = that.currency_iso
                product['quantity'] = item.Qty
                product['price'] = item.Price

                return product
            })

            console.log('optimize99_confirm_order_products', products)
            // 用購買的商品挑出最近有看過的view
            let recent_seen_views = []
            let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
            products.forEach(function(product) {
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }

                    }
                }
            })

            console.log('optimize99_confirm_order_recent_seen_views ', recent_seen_views)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)
            let events = []
            events = recent_seen_views.map(function(recent_seen_view){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": order.payProcessData.TradesOrderGroup.TradesOrderGroup_Code,
                    "clid": clid,
                    "vid": recent_seen_view,
                    "url": decodeURIComponent(window.location.href),
                    "value": order.payProcessData.TradesOrderGroup.TradesOrderGroup_TotalPayment,
                    "content": {
                        contents: products,
                    }
                }
                return event
            })

            console.log('optimize99_confirm_order_events:', events)

            if (events.length === 0) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": order.payProcessData.TradesOrderGroup.TradesOrderGroup_Code,
                    "clid": clid,
                    "vid": "",
                    "url": decodeURIComponent(window.location.href),
                    "value": order.payProcessData.TradesOrderGroup.TradesOrderGroup_TotalPayment,
                    "content": {
                        contents: products,
                    }
                }

                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_nineyi_confirmOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )
            }

            events.forEach(function(event, event_idx){
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_nineyi_confirmOrder',
                    "request_payload":event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": clid,
                })
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })
    
            recent_seen_views.forEach(function(recent_seen_view){
                products.forEach(function(product) {
                    if (container_storage['view_product'][product.content_id] && container_storage['view_product'][product.content_id][recent_seen_view]) {
                        delete container_storage['view_product'][product.content_id][recent_seen_view]
                    }
                })
            })
    
            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))
            console.log('optimize99_confirm_order_container_storage:', container_storage)
            
        } catch (error) {
            console.log('error', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_nineyi_confirmOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }
    }

    prePlaceOrderBtn(clid){
        let that = this
        console.log('optimize99_prePlaceOrderBtn', clid)
        document.addEventListener('click', function(event){
            // console.log('click', event)

            let target_ele = event.target
            if (target_ele instanceof HTMLElement === false) {
                if (target_ele.parentElement instanceof HTMLElement === false) {
                    return
                }
                else {
                    target_ele = target_ele.parentElement 
                }
            }

            let classname = target_ele.className
            console.log('classname',classname.indexOf('CustomButton'))
            if (classname.indexOf('CustomButton') !== -1) {
                that.prePlaceOrder(clid)
            }
            
        })
    }

    async prePlaceOrder(target_clid){
        let that = this
        console.log('optimize99_checkout_preorder')
        try {
            let url = new URL(window.location.href) 
            let tmp_order_id = localStorage.getItem('cartUniqueKey')
            let clid = target_clid
            let value_ele = document.querySelector('[class*="TotalAmountNumber"]')
            let value = utilsHelper.getNumbersFromString(value_ele.innerText)
            let products = []
            let cart = null
            for (let idx = 0; idx < dataLayer.length; idx++) {
            
                let param = dataLayer[idx]
            
                if (param[1] !== 'begin_checkout') {
                    continue
                }
            
                cart = param[2]
            }

            if (cart) {
                products = cart.items.map(function(item){
                    let product = {}
                    // 用來找看過哪些view的product_id都用平台id
                    product['content_id'] = item.id
                    product['content_name'] = item.name
                    product['price'] = item.price
                    product['quantity'] = item.quantity
                    return product
                })
            }

            console.log(cart)

            let recent_seen_views = []
            let container_storage = JSON.parse(localStorage.getItem(this.storage_key))
            products.forEach(function(product){
                if (container_storage['view_product'][product.content_id]) {
                    let product_views = Object.keys(container_storage['view_product'][product.content_id])
                    for (let idx = 0 ; idx < product_views.length; idx++) {
                        let view = container_storage['view_product'][product.content_id][product_views[idx]]
                        let last_view_at = view.last_view_at
                        let now = new Date().getTime()
                        let duration = now - parseInt(last_view_at)
                        let expired_time = 1000 * 60 * that.expired_min
                        if (duration < expired_time) {
                            if (recent_seen_views.includes(product_views[idx]) === false) {
                                recent_seen_views.push(product_views[idx])
                            }
                        }
                        else {
                            delete container_storage['view_product'][product.content_id][product_views[idx]]
                        }

                    }
                }
            })

            console.log('optimize99_checkout_recent_seen_views ', recent_seen_views)
            let plugin_event = {}
            try {
                let pagePlugin = new PagePlugin(
                    this.container_id, this.config
                )
                plugin_event = pagePlugin.purchaseEvent(products)
            } catch (error) {
                console.log('purchase_plugin_error:', error)
            }
            console.log('purchase_plugin_event:', plugin_event)

            let events = []
            events = recent_seen_views.map(function(view_id){
                let event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": `tmp-${tmp_order_id}`,
                    "clid": clid,
                    "vid": view_id,
                    "domain": window.location.hostname,
                    "email": tmp_order_id,
                    "url": window.location.href,
                    "value": value,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                return event
            })

            that.logHelper.send({
                "level": 'info',
                "stage": 'trace_nineyi_prePlaceOrder_before',
                "request_payload": events,
                "api_url": that.config.API_ENDPOINT + '/view/report',
                "clid": utilsHelper.getClidByContainerId(that.storage_key),
            })
            console.log('optimize99_checkout_events ', events)

            if (events.length === 0) {
                let force_event = {
                    "container_id": that.container_id,
                    "event": "PlaceAnOrder",
                    "event_id": `tmp-${tmp_order_id}`,
                    "clid": clid,
                    "vid": "",
                    "domain": window.location.hostname,
                    "email": tmp_order_id,
                    "url": window.location.href,
                    "value": value,
                    "content": {
                        contents: products,
                        currency: that.currency_iso
                    }
                }
                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0) {
                    force_event["content"]['sales_counter'] = plugin_event['sales_counter']
                }
                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    force_event
                )

                that.logHelper.send({
                    "level": 'info',
                    "view": "",
                    "stage": 'trace_nineyi_prePlaceOrder_force',
                    "request_payload": force_event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })
            }

            events.forEach(function(event, event_idx){

                if (plugin_event['sales_counter'] && plugin_event['sales_counter'].length > 0 && event_idx === 0) {
                    event["content"]['sales_counter'] = plugin_event['sales_counter']
                }

                that.logHelper.send({
                    "level": 'info',
                    "view": event.vid,
                    "stage": 'trace_nineyi_prePlaceOrder',
                    "request_payload": event,
                    "api_url": that.config.API_ENDPOINT + '/view/report',
                    "clid": utilsHelper.getClidByContainerId(that.storage_key),
                })

                utilsHelper.callAPI(
                    '', 
                    'POST', 
                    that.config.API_ENDPOINT + '/view/report', 
                    event
                )
            })

            localStorage.setItem(this.storage_key, JSON.stringify(container_storage))

        } catch (error) {
            console.log('error', error)
            this.logHelper.send({
                "level": 'error',
                "stage": 'trace_nineyi_prePlaceOrder',
                'error_trace': {
                    error_message: error.message,
                    error_stack: error.stack,
                }
            })
        }

    }

    async completeOrder(from){
        let order_id = ''
        let that = this
        if (from === 'login') {
            let url = new URL(window.location.href)
            let rt = url.searchParams.get('rt')
            if (!rt) {
                return
            }

            if (rt.includes('ThirdPartyPayment') === false) {
                return
            }

            let rt_url = new URL(rt)

            order_id = rt_url.searchParams.get('k')

            console.log('optimize99_confirm_order_no_clid')
            
            let event_data = {
                "container_id": that.container_id,
                "domain": window.location.hostname,
                "email": order_id,
                "order_id": order_id,
                "value": -1,
            }

            this.logHelper.send({
                "level": 'info',
                "stage": `trace_nineyi_confirmOrder_no_clid_${from}`,
                "request_payload": event_data,
                "api_url": this.config.API_ENDPOINT + '/view/complete',
            })

            await utilsHelper.callAPI(
                '', 
                'POST', 
                this.config.API_ENDPOINT + '/view/complete', 
                event_data
            )

        }
        else if(from === 'order_finished') {
            let url = new URL(window.location.href)
            let order_id = url.searchParams.get('k')
            let event_data = {
                "container_id": that.container_id,
                "domain": window.location.hostname,
                "email": order_id,
                "order_id": `tmp-${order_id}`,
                "value": -1,
            }

            this.logHelper.send({
                "level": 'info',
                "stage": `trace_nineyi_confirmOrder_no_clid_${from}`,
                "request_payload": event_data,
                "api_url": this.config.API_ENDPOINT + '/view/complete',
            })

            await utilsHelper.callAPI(
                '', 
                'POST', 
                this.config.API_ENDPOINT + '/view/complete', 
                event_data
            )
        }
    }
}